import React from "react";


class PageSearchResult extends React.Component {
    render() {
        let attribute = this.props.attribute
        return (
            <ol>
                {
                    attribute.map((item, idx) => (
                        <li className="b_algo" data-id="" iid="" data-bm="5" key={item} >
                        <div><a className="tilk" href="{item.detail_url}" h="ID=SERP,5239.1" target="_blank">
                            <div className="tpic"><div className="wr_fav" data-priority="2"><div className="cico siteicon">
                                <img alt=''></img></div>
                                </div></div><div className="tptxt">
                            <div className="tptt">{item.title}</div><div className="tpmeta"><div className="b_attribution" ><cite>{item.cite_url} › zh-cn › explore.…</cite></div></div></div></a></div><div className="b_imgcap_altitle b_imgcap_nosc">
                                <div className="b_imagePair square_mp reverse"><div className="inner">
                                    <div><div className="b_greyBackgroundModal"></div></div></div><h2><a href="{item.detail_url}" h="ID=SERP,5239.2" target="_blank">{item.breif_content}</a></h2>
                                <p className="b_lineclamp3">{item.content}</p></div></div><div className="b_caption b_rich" role="contentinfo"></div><div elementtiming="frp.MiddleOfPage"> &nbsp; 
                                    </div>
                        </li>
                    ))
                }
            </ol>
        );
    }
}


export default PageSearchResult;

